<template>
  <div class="wrap">
    <table border="1px">
      <tr>
        <td class="">No</td>
        <td class="detail">
          <v-textarea
            auto-grow
            row="1"
            readonly
            v-model="serial"
          ></v-textarea>
        </td>
      </tr>
      <tr>
        <td>檢驗項目英文名稱</td>
        <td class="detail">
          <v-textarea
            auto-grow
            row="1"
            readonly
            v-model="IsiEng"
          ></v-textarea>
        </td>
      </tr>
      <tr>
        <td>檢驗項目中文名稱</td>
        <td class="detail">
          <v-textarea
            auto-grow
            row="1"
            readonly
            v-model="IsiCh"
          ></v-textarea>
        </td>
      </tr>
      <tr>
        <td>委託狀態</td>
        <td class="detail">
          <v-textarea
            auto-grow
            row="1"
            readonly
            v-model="IsiEntrust"
          ></v-textarea>
        </td>
      </tr>
      <tr>
        <td>檢驗項目</td>
        <td class="detail">
          <v-textarea auto-grow row="1" readonly v-model="IsiName"></v-textarea>
        </td>
      </tr>
      <tr>
        <td>檢驗表單</td>
        <td class="detail">
          <v-textarea auto-grow row="1" readonly v-model="IsiForm"></v-textarea>
        </td>
      </tr>
      <tr>
        <td>健保代碼</td>
        <td class="detail">{{ IsiHCode }}</td>
      </tr>
      <tr>
        <td>項目代碼</td>
        <td class="detail">
          <v-textarea
            auto-grow
            row="1"
            readonly
            v-model="IsiICode"
          ></v-textarea>
        </td>
      </tr>
      <tr>
        <td>給付點數</td>
        <td class="detail">{{ IsiPoint }}</td>
      </tr>
      <tr>
        <td>自費收費</td>
        <td class="detail">
          <v-textarea
            auto-grow
            row="1"
            readonly
            v-model="IsiCharge"
          ></v-textarea>
        </td>
      </tr>
      <tr>
        <td>採檢容器</td>
        <td class="detail">
          <div v-for="(item, key) in img" :key="key">
            <v-img max-height="150" max-width="250" :src="item"></v-img>
            {{ imgList[key] }}
          </div>
        </td>
      </tr>
      <tr>
        <td>檢體量</td>
        <td class="detail">
          <v-textarea
            auto-grow
            row="1"
            readonly
            v-model="IsiAmount"
          ></v-textarea>
        </td>
      </tr>
      <tr>
        <td>注意事項</td>
        <td class="detail">
          <v-textarea
            auto-grow
            row="1"
            readonly
            v-model="IsiNotice"
          ></v-textarea>
        </td>
      </tr>
      <tr>
        <td>檢驗方法</td>
        <td class="detail">
          <v-textarea
            auto-grow
            row="1"
            readonly
            v-model="IsiMethod"
          ></v-textarea>
        </td>
      </tr>
      <tr>
        <td>可送檢時間</td>
        <td class="detail">
          <v-textarea
            auto-grow
            row="1"
            readonly
            v-model="IsiReceive"
          ></v-textarea>
        </td>
      </tr>
      <tr>
        <td>檢體傳送要求</td>
        <td class="detail">
          <v-textarea
            auto-grow
            row="1"
            readonly
            v-model="IsiRequire"
          ></v-textarea>
        </td>
      </tr>
      <tr>
        <td>報告時效</td>
        <td class="detail">
          <v-textarea
            auto-grow
            row="1"
            readonly
            v-model="IsiTimeLimit"
          ></v-textarea>
        </td>
      </tr>
      <tr>
        <td>檢驗組別及聯絡方式</td>
        <td class="detail">
          <v-textarea
            auto-grow
            row="1"
            readonly
            v-model="IsiContact"
          ></v-textarea>
        </td>
      </tr>
      <tr>
        <td>生物參考區間</td>
        <td class="detail">
          <v-textarea
            auto-grow
            row="1"
            readonly
            v-model="IsiRefer"
          ></v-textarea>
        </td>
      </tr>
      <tr>
        <td>附加檔案</td>
        <td class="detail">
          <div v-for="(item, key) in file" :key="key">
            <a :href="item">{{fileList[key]}}</a>
          </div>
        </td>
      </tr>
      <tr>
        <td>追加(requesting additional) /複驗(repeat)條件</td>
        <td class="detail">
          <v-textarea
            auto-grow
            row="1"
            readonly
            v-model="IsiAddRepeat"
          ></v-textarea>
        </td>
      </tr>
      <tr>
        <td>實驗室解釋</td>
        <td class="detail">
          <v-textarea
            auto-grow
            row="1"
            readonly
            v-model="IsiExplain"
          ></v-textarea>
        </td>
      </tr>
      <tr>
        <td>生效日期</td>
        <td class="detail">
          <v-textarea readonly v-model="IsiStart"></v-textarea>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serial: null,
      IsiEng:'',
      IsiEntrust:'',
      IsiName: "",
      IsiForm: "",
      IsiHCode: "",
      IsiICode: "",
      IsiPoint: "",
      IsiCharge: "",
      IsiAmount: "",
      IsiNotice: "",
      IsiMethod: "",
      IsiReceive: "",
      IsiRequire: "",
      IsiTimeLimit: "",
      IsiContact: "",
      IsiRefer: "",
      IsiAddRepeat: "",
      IsiExplain: "",
      IsiStart: "",
      imgList: [],
      img: [],
      fileList: [],
      file: [],
      data: "",
    };
  },
  methods: {
    getTime() {
      function paddingLeft(str, len) {
        str = "" + str;
        if (str.length >= len) {
          return str;
        } else {
          return "0" + str;
        }
      }
      var NowDate = new Date();
      var Y = NowDate.getFullYear();
      var M = NowDate.getMonth() + 1;
      M = paddingLeft(M, 2);
      var D = NowDate.getDate();
      D = paddingLeft(D, 2);
      var h = NowDate.getHours();
      h = paddingLeft(h, 2);
      var m = NowDate.getMinutes();
      m = paddingLeft(m, 2);
      var s = NowDate.getSeconds();
      s = paddingLeft(s, 2);
      return Y + M + D + h + m + s;
    },
  },
  mounted() {
    console.log(this.getTime());
    this.serial = this.$route.params.serial;
    sessionStorage.setItem("serial", JSON.stringify(this.serial));
    const api = process.env.VUE_APP_LETTER_API + this.serial;
    console.log(api);
    require("isomorphic-fetch");
    fetch(api, {
      method: "POST",
      body: JSON.stringify({ ItemSerial: "1" }),
    })
      .then((res) => res.json())
      .catch((error) => {
        console.error("Error:", error);
      })
      .then((response) => {
        console.log("Success:", response.data);
        this.data = response.data[0];
        this.IsiEng = this.data["IsiEng"];
        this.IsiCh = this.data["IsiCh"];
        this.IsiEntrust = JSON.parse(this.data["IsiEntrust"])["IsiEntrust"];
        this.IsiName = JSON.parse(this.data["IsiName"])["IsiName"];
        this.IsiForm = JSON.parse(this.data["IsiForm"])["IsiForm"];
        this.IsiHCode = this.data["IsiHCode"];
        this.IsiICode = JSON.parse(this.data["IsiICode"])["IsiICode"];
        this.IsiPoint = this.data["IsiPoint"];
        this.IsiCharge = JSON.parse(this.data["IsiCharge"])["IsiCharge"];
        var ImgStatus = this.data["IsiImgStatus"].trim();
        if (ImgStatus == "Y") {
          this.imgList = this.data["IscImgTitle"];
          console.log(this.imgList);
          for (var i in this.imgList) {
            var api =
              process.env.VUE_APP_DOWNLOAD_IMG +
              this.getTime() +
              this.serial +
              "|" +
              this.imgList[i];
            this.img.push(api);
            console.log(api);
          }
        }
        this.IsiAmount = JSON.parse(this.data["IsiAmount"])["IsiAmount"];
        this.IsiNotice = JSON.parse(this.data["IsiNotice"])["IsiNotice"];
        this.IsiMethod = JSON.parse(this.data["IsiMethod"])["IsiMethod"];
        this.IsiReceive = JSON.parse(this.data["IsiReceive"])["IsiReceive"];
        this.IsiRequire = JSON.parse(this.data["IsiRequire"])["IsiRequire"];
        this.IsiTimeLimit = JSON.parse(this.data["IsiTimeLimit"])[
          "IsiTimeLimit"
        ];
        this.IsiContact = JSON.parse(this.data["IsiContact"])["IsiContact"];
        this.IsiRefer = JSON.parse(this.data["IsiRefer"])["IsiRefer"];
        var FileStatus = this.data["IsiAffix"].trim();
        if (FileStatus == "Y") {
          this.fileList = this.data["IsaAddTitle"];
          console.log(this.fileList);
          for (var j in this.fileList) {
            var api2 =
              process.env.VUE_APP_DOWNLOAD_FILE +
              this.getTime() +
              this.serial +
              "|" +
              this.fileList[j];
            this.file.push(api2);
            console.log(api2);
          }
        }
        this.IsiAddRepeat = JSON.parse(this.data["IsiAddRepeat"])[
          "IsiAddRepeat"
        ];

        this.IsiExplain = JSON.parse(this.data["IsiExplain"])["IsiExplain"];
        this.IsiStart = JSON.parse(this.data["IsiStart"])["IsiStart"];
      });
  },
};
</script>

<style>

</style>
